import React, {useCallback, useEffect, useRef, useState} from 'react';
import {inject, observer} from "mobx-react";
import {db} from "../../../../firebase/Firebase";
import {FormContainer, LayoutChild} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import ExcelJS from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import format from "date-fns/format";
import DataGrid, {Column, Export, Pager, Paging, SearchPanel, Sorting} from "devextreme-react/data-grid";
import {jsPDF} from 'jspdf';
import {exportDataGrid as exportDataGridToPdf} from 'devextreme/pdf_exporter';
import saveAs from 'file-saver';
import autoTable from 'jspdf-autotable'
import VerticalSpace from "../../../../palette/VerticalSpace";
import {Animated} from "react-animated-css";
import Alerts from "../../../../palette/Alerts";

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function DriverRoutes(props) {

    const {DataStore, ControlStore} = props
    const {companyName, idCompany} = DataStore
    const {driverFinished} = ControlStore

    const isMounted = useMountedState()
    const dataGridRef = React.createRef();

    const [loading, setLoading] = useState(false)
    const [dataSource, setDataSource] = useState([]);
    const [trigger, setTrigger] = useState(false);

    useEffect(() => {
        const GetDriverManagement = async () => {
            const newArray = [];
            let ID = 0;
            await db.collection(companyName).doc(idCompany).collection('DriverManagement')
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        if (doc.exists) {
                            doc.data().vehicleData.dataRoutesSchedule.forEach(items => {
                                ID = ID + 1;
                                const obj = {
                                    ...items,
                                    id: doc.id,
                                    ID: ID,
                                    names: `${doc.data().name} ${doc.data().lastName}`
                                };
                                newArray.push(obj);
                            })
                        } else {
                            setDataSource([]);
                        }
                    });
                    setDataSource(newArray);
                    setLoading(true)
                })
                .catch(function () {
                    setDataSource(newArray);
                });
        };
        if (isMounted()) {
            GetDriverManagement().catch(() => setTrigger(!trigger));
        }
    }, [trigger, isMounted]);

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            topLeftCell: {row: 6, column: 2},
            customizeCell: ({gridCell, excelCell}) => {

                if (gridCell.rowType === 'data') {
                    if (excelCell.row % 2 === 0) {
                        excelCell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'C6EFCE'},
                            bgColor: {argb: 'C6EFCE'}
                        };
                    }
                }
            }
        }).then(function () {

            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Rutas conductores`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'}

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'}

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'Lista-rutas-conductores.xlsx');
            });
        });
        e.cancel = true;
    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF();
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 35, left: 15}
            }
        };

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Reporte : Rutas conductores`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(16)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 10, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 17, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 22, {baseline: 'top'});

                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('Rutas-Conductores.pdf');
        });
    }

    const onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
                location: 'before',
                widget: 'dxButton',
                options: {
                    width: 120,
                    text: 'Imprimir',
                    elementAttr: {id: 'btn-pdf'},
                    icon: 'far fa-file-pdf',
                    onClick: exportGridPDF
                }
            },
        )
    }

    return (
        <>
            {!driverFinished &&
            <LayoutChild color='transparent' percent={95} margin='auto' top={25}>
                <Alerts severity="warning" body={'No se han gestionado conductores!'}/>
            </LayoutChild>
            }
            <VerticalSpace space={30}/>
            {driverFinished && <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                <div className="grid-container">
                    <HeaderPage icon={'far fa-compass'} text={'Estado de viajes'} load={loading}
                                textLoad={'Cargando....'}/>
                    <FormContainer>
                        <DataGrid
                            ref={dataGridRef}
                            id="data-routes"
                            dataSource={dataSource}
                            keyExpr="ID"
                            allowColumnReordering={true}
                            showBorders={true}
                            onToolbarPreparing={onToolbarPreparing}
                            rowAlternationEnabled={true}
                            noDataText={'Esperando datos...'}
                            onExporting={onExporting}
                        >
                            <SearchPanel visible={true}
                                         width={240}
                                         placeholder="Buscar"/>
                            <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                            <Sorting mode="multiple"/>
                            <Paging defaultPageSize={15}/>
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[5, 10, 20]}
                                showInfo={true}/>
                            <Column dataField="names" alignment={'center'} caption={'Conductor'} cssClass={'cls'}/>
                            <Column dataField="routeName" alignment={'center'} caption={'Ruta'} cssClass={'cls'}/>
                            <Column dataField="days" alignment={'center'} caption={'Dia'} cssClass={'cls'}/>
                            <Column dataField="hour" alignment={'center'} caption={'Hora'} cssClass={'cls'}/>
                        </DataGrid>
                    </FormContainer>
                </div>
            </Animated>}
        </>
    )
}


export default inject('DataStore', 'ControlStore')(observer(DriverRoutes));